// Server-notification popup. When Ghost (admin) broadcasts in SERVER mode, every connected player
// sees a pixel-styled banner drop in at the top of the screen — just below the selected-character
// stats card (which sits at top:14px). Banners stack and auto-dismiss.

import { injectTheme } from "./theme.js";

const STYLE_ID = "ghostland-servernotice-style";
const WRAP_ID = "gl-servernotice";
const LIFETIME_MS = 8000;

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Silkscreen:wght@400;700&display=swap');
#${WRAP_ID} {
  position: fixed; top: 84px; left: 50%; transform: translateX(-50%); z-index: 13;
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  pointer-events: none; width: max-content; max-width: 92vw;
}
.gl-srv-note {
  display: flex; align-items: center; gap: 10px; padding: 9px 14px;
  background: #050208; border: 2px solid #ffcf4d; image-rendering: pixelated;
  box-shadow: 0 0 0 2px #000, 4px 4px 0 rgba(0,0,0,.6), 0 0 12px 1px rgba(255,207,77,.35);
  animation: gl-srv-in .22s ease-out both;
}
.gl-srv-note.out { animation: gl-srv-out .3s ease-in both; }
.gl-srv-note .tag {
  font-family: 'Silkscreen', ui-monospace, monospace; font-size: 9px; letter-spacing: 1px;
  color: #050208; background: #ffcf4d; padding: 3px 6px; white-space: nowrap;
}
.gl-srv-note .msg {
  font-family: 'Silkscreen', ui-monospace, monospace; font-size: 11px; line-height: 1.4;
  color: #f4f4f4; text-shadow: 1px 1px 0 #000; max-width: 70vw; overflow-wrap: anywhere;
}
@keyframes gl-srv-in  { from { transform: translateY(-14px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
@keyframes gl-srv-out { from { transform: translateY(0); opacity: 1; } to { transform: translateY(-10px); opacity: 0; } }
`;

let wrap: HTMLDivElement | null = null;

function ensure(): void {
  injectTheme();
  if (!document.getElementById(STYLE_ID)) {
    const s = document.createElement("style"); s.id = STYLE_ID; s.textContent = CSS; document.head.appendChild(s);
  }
  if (wrap) return;
  wrap = document.createElement("div");
  wrap.id = WRAP_ID;
  document.body.appendChild(wrap);
}

/** Show a notification banner (auto-dismisses). `tagText` is the corner label (default "SERVER"). */
export function showServerNotice(text: string, tagText = "SERVER"): void {
  const msg = String(text ?? "").trim();
  if (!msg) return;
  ensure();
  const note = document.createElement("div");
  note.className = "gl-srv-note";
  const tag = document.createElement("span"); tag.className = "tag"; tag.textContent = (tagText || "SERVER").toUpperCase();
  const body = document.createElement("span"); body.className = "msg"; body.textContent = msg;
  note.append(tag, body);
  wrap!.appendChild(note);
  window.setTimeout(() => {
    note.classList.add("out");
    window.setTimeout(() => note.remove(), 320);
  }, LIFETIME_MS);
}

/** Tear down all banners (on world dispose). */
export function destroyServerNotice(): void {
  wrap?.remove();
  wrap = null;
}
